import { createTheme } from '@mui/material/styles';
import { Palette as InvestorPalette } from '../../components/styles/Palette';

const MANAGER = {
  ink: '#1E293B',
  muted: '#64748B',
  border: '#E2E8F0',
  surface: '#FFFFFF',
  canvas: '#F8FAFC',
  primary: '#4338CA',
  primaryDark: '#363B6E',
  sidebar: '#1E293B',
  sidebarActive: '#334155',
};

export const managerColors = MANAGER;

export const investorColors = {
  ink: InvestorPalette.default.text ?? '#113833',
  muted: '#4a6854',
  border: '#d3ddd5',
  surface: '#FFFFFF',
  canvas: InvestorPalette.tone2.background,
  primary: InvestorPalette.default.buttonBg ?? '#143c34',
  accent: InvestorPalette.tone3.background,
  header: InvestorPalette.tone4.background,
  highlight: InvestorPalette.default.graphLine ?? '#1E7F6C',
};

const sharedComponents = {
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: { root: { textTransform: 'none' as const, fontWeight: 600, borderRadius: 8 } },
  },
  MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontWeight: 600,
        fontSize: '0.75rem',
        textTransform: 'uppercase' as const,
        letterSpacing: '0.04em',
      },
    },
  },
  MuiTab: {
    styleOverrides: { root: { textTransform: 'none' as const, fontWeight: 600, minHeight: 44 } },
  },
};

export const managerTheme = createTheme({
  palette: {
    primary: { main: MANAGER.primary, dark: MANAGER.primaryDark },
    secondary: { main: '#0F766E' },
    text: { primary: MANAGER.ink, secondary: MANAGER.muted },
    background: { default: MANAGER.canvas, paper: MANAGER.surface },
    divider: MANAGER.border,
    success: { main: '#15803D' },
    warning: { main: '#B45309' },
    error: { main: '#B91C1C' },
    info: { main: '#1D4ED8' },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h4: { fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: '1.6rem' },
    h5: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '1.25rem' },
    h6: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '1.05rem' },
    body2: { fontSize: '0.875rem' },
  },
  shape: { borderRadius: 10 },
  components: {
    ...sharedComponents,
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 12 } } },
  },
});

export const investorTheme = createTheme({
  palette: {
    primary: { main: investorColors.primary },
    secondary: { main: investorColors.highlight },
    text: { primary: investorColors.ink, secondary: investorColors.muted },
    background: { default: investorColors.canvas, paper: investorColors.surface },
    divider: investorColors.border,
    success: { main: '#1E7F6C' },
    warning: { main: '#b26a00' },
    error: { main: '#a73232' },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h4: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '1.6rem' },
    h5: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '1.25rem' },
    h6: { fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '1.05rem' },
  },
  shape: { borderRadius: 6 },
  components: {
    ...sharedComponents,
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 8 } } },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none' as const, fontWeight: 600, borderRadius: 6 },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600, borderRadius: 6 } } },
  },
});
